// Starter Kit Frontpage - Simple Image Swap
// Swaps main image when items are clicked

class StarterKitFrontpage {
  constructor(container) {
    this.container = container;
    this.imageElement = container.querySelector('#skf-main-image');
    this.mainImageSrc = this.imageElement?.getAttribute('data-main-src');
    this.mainImageSrcset = this.imageElement?.getAttribute('data-main-srcset');
    this.currentItemId = null;
    this.itemImages = {};

    this.init();
  }

  init() {
    if (!this.imageElement) {
      console.warn('⚠️ Starter Kit Frontpage: Main image element not found - image swapping disabled');
      // Continue initialization even without image - buttons still need to work
    } else {
      // Collect item image URLs from DOM only if image element exists
      this.collectItemImages();
    }

    // Bind click handlers (these work independently of image)
    this.bindEvents();

    // Wire builder integration if inside builder
    this.wireBuilderIntegration();
  }

  collectItemImages() {
    const imageData = this.container.querySelectorAll('[data-item-image]');
    imageData.forEach((el) => {
      const itemId = el.getAttribute('data-item-image');
      const src = el.getAttribute('data-image-src');
      const srcset = el.getAttribute('data-image-srcset');
      if (itemId && src) {
        this.itemImages[itemId] = {
          src: src,
          srcset: srcset || ''
        };
      }
    });
  }

  bindEvents() {
    const itemButtons = this.container.querySelectorAll('.skf-item__button');

    itemButtons.forEach((button) => {
      const itemId = button.getAttribute('data-item-id');
      if (!itemId) return;

      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleItemClick(itemId);
      });

      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleItemClick(itemId);
        }
      });
    });
  }

  handleItemClick(itemId) {
    // If clicking the already-active item, collapse it
    if (this.currentItemId === itemId) {
      if (this.imageElement && this.mainImageSrc) {
        this.imageElement.src = this.mainImageSrc;
        if (this.mainImageSrcset) {
          this.imageElement.srcset = this.mainImageSrcset;
        }
      }
      this.currentItemId = null;
      this.updateItemStates(null);
      return;
    }

    // Activate the clicked item
    if (this.imageElement) {
      const itemData = this.itemImages[itemId];
      if (itemData) {
        this.imageElement.src = itemData.src;
        if (itemData.srcset) {
          this.imageElement.srcset = itemData.srcset;
        }
      }
    }
    this.currentItemId = itemId;
    this.updateItemStates(itemId);
  }

  updateItemStates(activeId) {
    // Update button states and expansion
    const buttons = this.container.querySelectorAll('.skf-item__button');
    buttons.forEach((btn) => {
      const itemId = btn.getAttribute('data-item-id');
      const isActive = itemId === activeId;
      btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
  }

  wireBuilderIntegration() {
    if (window.starterKitBuilderInstance) {
      this.wireCTAButtons();
      return;
    }

    // Builder not ready yet — retry up to 10 times (50ms intervals = 500ms max wait)
    let attempts = 0;
    const retryInterval = setInterval(() => {
      attempts++;
      if (window.starterKitBuilderInstance) {
        clearInterval(retryInterval);
        this.wireCTAButtons();
      } else if (attempts >= 10) {
        clearInterval(retryInterval);
        console.warn('Starter Kit Builder not available after 500ms — CTA buttons using fallback');
        // Fallback: wire CTAs to scroll to builder section directly
        const ctaButtons = this.container.querySelectorAll('.skf-hero__cta');
        ctaButtons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            const builderSection = document.querySelector('[data-starter-kit-builder]');
            if (builderSection) {
              builderSection.scrollIntoView({ behavior: 'smooth' });
            }
          });
        });
      }
    }, 50);
  }

  wireCTAButtons() {
    const ctaButtons = this.container.querySelectorAll('.skf-hero__cta');
    ctaButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        window.starterKitBuilderInstance.goToStep(1);
      });
    });
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('[data-starter-kit-frontpage]');
  containers.forEach((container) => {
    new StarterKitFrontpage(container);
  });
});
